<script>
  import { BasicDropdown, logClickToGA } from "@urbaninstitute/dataviz-components";
  import { getConfig } from "$lib/utils/config.js";

  let {
    currentState = $bindable(),
    stateDropdownData,
    stateTextLabel = undefined,
    introText = null,
    label = "select a state or district"
  } = $props();
  const config = getConfig()();
</script>

<h3 class="detail-header" style:--highlight-color={config.map.hoverStroke}>
  {#if introText}
    {introText}
  {/if}
  <BasicDropdown
    id="detail-header-state-select"
    inlineLabel={label}
    placeholder={label}
    data={stateDropdownData}
    bind:value={currentState}
    on:change={(e) => {
      // logClickToGA(e.target, "state-dropdown-select--" + e.target.value);
    }}
    variant="secondary-yellow"
  />
  {#if currentState && stateTextLabel}
    <span>{stateTextLabel}</span>
  {/if}
</h3>

<style>
  .detail-header {
    display: flex;
    line-height: 1;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: flex-start;
    /* justify-content: center; */
    column-gap: var(--spacing-2);
    row-gap: 0.875rem;
    padding-bottom: var(--spacing-4);
    margin-top: 0;
  }
  /* make dropdowns sit inline */
  .detail-header :global(.dropdown-parent) {
    display: inline-block !important;
    padding: 0 !important;
    transform: translateY(-1px) !important;
  }
  .detail-header :global(.dropdown-container) {
    width: fit-content !important;
  }
  .detail-header :global(.dropdown-container select) {
    padding-right: var(--spacing-10) !important;
    font-size: var(--font-size-2xl) !important;
    background-color: transparent !important;
    border-color: transparent !important;
    border-bottom: 5px solid var(--highlight-color) !important;
    padding: 0 !important;
    padding-right: var(--spacing-8) !important;
  }

  .detail-header :global(.dropdown-container .icons) {
    padding-right: var(--spacing-1) !important;
    transform: translateY(-1rem);
  }
  @media (max-width: 540px) {
    .detail-header :global(.dropdown-container select) {
      font-size: var(--font-size-xl) !important;
    }
  }
</style>
